import { Column, Row } from '@/components/container/Container';
import { TextBodyMedium, TextHeadlineSmall } from '@/components/text/Texts';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { MdDangerous } from 'react-icons/md';

type Props = {
	title: string;
	message: string;
	rejectLabel?: string;
	acceptLabel?: string;
	onReject?: () => Promise<void>;
	onAccept?: () => Promise<void>;
}

const ConfirmModal = NiceModal.create(({
	title,
	message,
	rejectLabel,
	acceptLabel,
	onReject,
	onAccept,
}: Props) => {
	const modal = useModal();

	return (
		<ConfirmDialog
			unstyled
			visible={true}
			maskStyle={{ backgroundColor: '#00000047' }} // black-28
			content={(
				<Column className="p-6 rounded-[28px] w-[496px] bg-surfaceContainerHigh">
					<MdDangerous
						size={24}
						onClick={() => modal.remove()}
						className="mb-4 self-center text-error cursor-pointer"
					/>
					<TextHeadlineSmall className="mb-4 text-onSurface" text={title} />
					<TextBodyMedium className="mb-6 text-onSurfaceVariant" text={message} />
					<Row className="gap-2 self-end">
						{rejectLabel && (<Button
							onClick={async () => {
								await onReject?.();
								modal.remove();
							}}
							label={rejectLabel}
							pt={{
								root: { className: 'h-10 px-6 py-2 rounded-[100px] bg-primary' },
								label: { className: 'font-poppins text-label-large2 text-white' },
							}}
						/>)}
						{acceptLabel && (<Button
							onClick={async () => {
								await onAccept?.();
								modal.remove();
							}}
							label={acceptLabel}
							pt={{
								root: { className: 'h-10 px-6 py-2 rounded-[100px] bg-error' },
								label: { className: 'font-poppins text-label-large2 text-white' },
							}}
						/>)}
					</Row>
				</Column>
			)}
		/>
	);
});

export default ConfirmModal;
